import React, { useEffect, useState } from "react";

import { useLocation, Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Navbar = () => {
  let location = useLocation();

  const [currentRoute, setCurrentRoute] = useState("");

  useEffect(() => {
    setCurrentRoute(location.pathname);
  }, [location]);

  const matchesSm = useMediaQuery("(max-width:960px)");
  const matchesXs = useMediaQuery("(max-width:600px)");

  return (
    <Grid container style={{ padding: "2.5rem", color: "#EEEEEE" }}>
      <Grid
        item
        lg={"auto"}
        md={"auto"}
        sm={"auto"}
        xs={12}
        style={{ marginRight: "2.5rem" }}
      >
        <Link to="/about">
          <h2
            className="navbar-link-1"
            style={matchesXs ? { marginBottom: "1rem" } : {}}
          >
            <span
              style={
                currentRoute === "/about"
                  ? {
                      color: "#FFE665",
                      borderBottom: "6px solid #FFE665",
                      paddingBottom: "0.6rem",
                    }
                  : {}
              }
            >
              About
            </span>
          </h2>
        </Link>
      </Grid>
      <Grid
        item
        lg={"auto"}
        md={"auto"}
        sm={"auto"}
        xs={12}
        style={matchesXs ? { margin: "2rem 0" } : { marginRight: "2.5rem" }}
      >
        <Link to="/projects">
          <h2
            className="navbar-link-2"
            style={matchesXs ? { marginBottom: "1rem" } : {}}
          >
            <span
              style={
                currentRoute === "/projects"
                  ? {
                      color: "#80FF6C",
                      borderBottom: "6px solid #80FF6C",
                      paddingBottom: "0.6rem",
                    }
                  : {}
              }
            >
              Projects
            </span>
          </h2>
        </Link>
      </Grid>
      <Grid
        item
        lg={"auto"}
        md={"auto"}
        sm={"auto"}
        xs={12}
        style={{ marginRight: "2.5rem" }}
      >
        <Link to="/contact">
          <h2
            className="navbar-link-3"
            style={matchesXs ? { marginBottom: "1rem" } : {}}
          >
            <span
              style={
                currentRoute === "/contact"
                  ? {
                      color: "#D782FF",
                      borderBottom: "6px solid #D782FF",
                      paddingBottom: "0.6rem",
                    }
                  : {}
              }
            >
              Contact
            </span>
          </h2>
        </Link>
      </Grid>
      <Grid
        item
        lg
        md
        sm={12}
        xs={12}
        style={
          matchesSm
            ? { textAlign: "left", marginTop: "4rem" }
            : { textAlign: "right" }
        }
      >
        <h2 className="navbar-tagline">
          # I build{" "}
          <span
            style={{
              padding: "0.2rem 0.5rem 0.3rem",
              color: "#222831",
              backgroundColor: "#EEEEEE",
            }}
          >
            amazing
          </span>{" "}
          user interfaces
        </h2>
      </Grid>
    </Grid>
  );
};

export default Navbar;
